import { useToasterContext } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import classNames from "classnames"
import type { ReactNode } from "react"
import { useCallback } from "react"
import styles from "./PolicyViewerLink.module.scss"
import { GenericErrorToast } from "src/toasts"

interface Props {
  className?: string;
  children: ReactNode;
  policyDocumentName: string;
  policyDocument: undefined | {
    title: string;
    file: string;
  };
}

export function PolicyViewerLink(props: Props) {
  const {
    policyDocumentName,
    policyDocument,
    children,
    className,
  } = props

  const { showToast } = useToasterContext()

  const showLinkErrorToast = useCallback(
    () => {
      showToast(
        `missing-document-${policyDocumentName}`,
        GenericErrorToast,
      )
    },
    [
      showToast,
      policyDocumentName,
    ],
  )

  if (policyDocument) {
    return (
      <Link
        key="link"
        className={classNames(
          styles.link,
          className,
        )}
        to="/policy-viewer"
        target="_blank"
        search={{
          title: policyDocument.title,
          file: policyDocument.file,
        }}
        id={policyDocumentName}
      >
        {children}
      </Link>
    )
  }

  return (
    <button
      key="link"
      className={classNames(
        styles.linkButton,
        className,
      )}
      onClick={showLinkErrorToast}
    >
      {children}
    </button>
  )
}
